module.exports = __webpack_public_path__ + "img/h-banner05.82eb657c.jpg";